module.exports = __webpack_public_path__ + "static/media/deleteGrey.4473ade5.svg";